// Generated from ESF schema: topology
// Do not edit manually!
/** Cloud/infrastructure provider */
export var CloudProvider;
(function (CloudProvider) {
    CloudProvider["Gcp"] = "gcp";
    CloudProvider["Aws"] = "aws";
    CloudProvider["Azure"] = "azure";
    CloudProvider["Cloudflare"] = "cloudflare";
    CloudProvider["Local"] = "local";
})(CloudProvider || (CloudProvider = {}));
/** Type of topology change */
export var DeltaAction;
(function (DeltaAction) {
    DeltaAction["AddNode"] = "add_node";
    DeltaAction["RemoveNode"] = "remove_node";
    DeltaAction["UpdateNode"] = "update_node";
    DeltaAction["AddLink"] = "add_link";
    DeltaAction["RemoveLink"] = "remove_link";
    DeltaAction["UpdateLink"] = "update_link";
})(DeltaAction || (DeltaAction = {}));
/** Current status of a link */
export var LinkStatus;
(function (LinkStatus) {
    LinkStatus["Active"] = "active";
    LinkStatus["Degraded"] = "degraded";
    LinkStatus["Error"] = "error";
})(LinkStatus || (LinkStatus = {}));
/** Type of connection between nodes */
export var LinkType;
(function (LinkType) {
    LinkType["Tunnel"] = "tunnel";
    LinkType["Tcp"] = "tcp";
    LinkType["Udp"] = "udp";
    LinkType["Vpc"] = "vpc";
    LinkType["Websocket"] = "websocket";
    LinkType["Grpc"] = "grpc";
})(LinkType || (LinkType = {}));
/** Type of node lifecycle event */
export var NodeEventType;
(function (NodeEventType) {
    NodeEventType["Approval"] = "approval";
    NodeEventType["Update"] = "update";
    NodeEventType["Suspend"] = "suspend";
    NodeEventType["Revoke"] = "revoke";
})(NodeEventType || (NodeEventType = {}));
/** Current status of a node */
export var NodeStatus;
(function (NodeStatus) {
    NodeStatus["Healthy"] = "healthy";
    NodeStatus["Degraded"] = "degraded";
    NodeStatus["Error"] = "error";
    NodeStatus["Offline"] = "offline";
})(NodeStatus || (NodeStatus = {}));
/** Type of node in the network */
export var NodeType;
(function (NodeType) {
    NodeType["Edge"] = "edge";
    NodeType["Scatter"] = "scatter";
    NodeType["Consensus"] = "consensus";
    NodeType["Ops"] = "ops";
    NodeType["Bridge"] = "bridge";
    NodeType["Client"] = "client";
    NodeType["Cloudflare"] = "cloudflare";
})(NodeType || (NodeType = {}));
//# sourceMappingURL=topology.js.map